export enum GenericPaymentTxnStatus {    
    Unknown = 'Unknown',
    
    // Starting states /*

    /**
     * @todo Document what does it refer to and when to use
     */
    Initiated = 'Initiated',

    // Starting states */


    // Intermediary states /*

    /**
     * @todo Document what does it refer to and when to use
     */
    Pending = 'Pending',

    // Intermediary states */


    // End states /*
    
    /**
     * @todo Document what does it refer to and when to use
     */
    Success = 'Successful', // Payment Status
    
    Failed = 'Failed',
    
    /**
     * @todo Document what does it refer to and when to use
     */
    Completed = 'Completed', // Refund status

    /**
     * Used in OTM. Both Confirmed and Completed indicate a success state
     */
    Confirmed = 'Confirmed', // OTM status

    // End states */
};

export enum PaymentGatewaySettlementStatus {
    /**
     * We don't know the status of the settlement
     */
    // null

    /**
     * 
     * SETTLEMENT_CONFIRMATION_PENDING
     * We have got settlement confirmation from the payment gateway and we are waiting for the settlement confirmation from the bank
     */
    SETTLEMENT_CONFIRMATION_PENDING = '10',
    /**
     * SETTLED
     * The settlement is successful to our bank
     */
    SETTLED = '20',
}
